import React, { Component } from "react";
import { cloneDeep } from "lodash";
import mqtt from "mqtt";
import * as actions from "../../../redux/actions";
import QrReader from "react-qr-reader";
import Switch from "react-switch";
import util from "util";

// Redux
import { connect } from "react-redux";
import Input from "../../../components/uielements/input";
import Button from "../../../components/uielements/button";
import Form from "../../../components/uielements/form";
import Spin from "../../../components/uielements/spin";
import Color from "../../../assets/Color";
import Icon from "../../../assets/components/Icon";
import Validator, { validateField, validateForm } from "../../../helpers/validation";

import LayoutContentWrapper from "../../../components/utility/layoutWrapper";
import CustomPageStyle from "./style";
import SwitchService from "../SwitchService";
import moment from "moment";

import offBtn from "../../../assets/icon/off-btn.png";
import DropOffDRVM from "../../../assets/icon/DropOffDRVM.png";
import speaker from "../../../assets/icon/speaker.png";

import { APP_ENV, APP_VERSION } from "../../../settings";
import { MQTT_HOST } from "../../../settings";
import { store } from "../../../redux/store";


let env = store.getState().App.env;

const FormItem = Form.Item;

// ✅ Connection options (adjust as needed)
const options = {
  clientId: "DUMP",
  clean: true, // start fresh session
  connectTimeout: 5000, // ms before giving up on first connect
  reconnectPeriod: 3000, // ms before retry after disconnect
  keepalive: 60, // seconds to send ping
  username: "", // optional
  password: "", // optional
};

const activtyMessage = {
  user_verified: {
    en: "Login successful. Drop-off slot is opening, please drop your item.",
    cn: "登录成功。投口正在打开，请投递物品。",
    my: "Log masuk berjaya. Slot penghantaran sedang dibuka, sila masukkan barang anda."
  },
  user_unverified: {
    en: "Login failed. Please try again.",
    cn: "登录不成功。请重试。",
    my: "Log masuk gagal. Sila cuba lagi."
  },
  process_grading: {
    en: "The weighing is in progress, please wait.",
    cn: "称重正在计量，请稍等",
    my: "Penimbangan sedang dijalankan, sila tunggu."
  },
  grading_completed: {
    en: "The weight of your current delivery is %s kg, you have earned RM%s",
    cn: "您此次投递重量为%s公斤，获得收益为%s令吉",
    my: "Berat penghantaran anda kali ini ialah %s kg, anda telah mendapat RM%s"
  },
  grading_cancelled: {
    en: "Thank you for your support. We look forward to your next visit.",
    cn: "感谢您的支持，期待您的再次到来",
    my: "Terima kasih atas sokongan anda. Kunjungan anda yang seterusnya amat kami nantikan."
  },
  system_error: {
    en: "An unexpected error occurred. Please try again later.",
    cn: "发生意外错误。请稍后重试。",
    my: "Ralat yang tidak dijangka telah berlaku. Sila cuba sebentar lagi."
  },
  emergency_stop:{
		en: "Emergency Stop Triggered. Operation was paused.",
		cn: "紧急停止触发。设备运作暂停。",
		my: "Hentian Kecemasan Diaktifkan. Operasi telah dihentikan."
  },
  unlock_maglock: {
		en: "Scan successful. Lock is now open.",
		cn: "扫码成功，电磁锁已打开。",
		my: "Imbas berjaya. Kunci kini terbuka."
	},
	qrcode_unverified: {
		en: "Invalid QR code. Please contact the admin.",
		cn: "无效二维码，请联络管理员。",
		my: "Kod QR tidak sah. Sila hubungi pentadbir."
	}
}

// const SILENT_MP3 = "https://api-test.dumpster.com.my/audio/drvm/silent_1s.wav";
const voice_type = "url"
// const voice_type = "buffer"

class DRVM extends Component {
  constructor(props) {
    super(props);

    this.state = {
      page: "",
      screen: "",
      isConnected : false,
      lastPingTime : moment(),
      isConnectionFail: false,
      vm_status: "offline",
      err_msg: "",
      fields: {
        client_id: {
          value: "",
          validation: {
            rules: {},
            error_message: {}
          },
          valid: true
        },
        username: {
          value: "",
          validation: {
            rules: {},
            error_message: {}
          },
          valid: true
        },
        password: {
          value: "",
          validation: {
            rules: {},
            error_message: {}
          },
          valid: true
        },
        weight: {
          value: "",
          validation: {
            rules: {},
            error_message: {}
          },
          valid: true
        },
        recyclabes_snapshot: {
          value: null,
          validation: {
            rules: {},
            error_message: {}
          },
          valid: true
        },
        recyclabes_snapshot_url: {
          value: "",
          validation: {
            rules: { required: false },
          },
          valid: true
        },
        autoidrop_snapshot: {
          value: null,
          validation: {
            rules: {},
            error_message: {}
          },
          valid: true
        },
        autoidrop_snapshot_url: {
          value: "",
          validation: {
            rules: { required: false },
          },
          valid: true
        },
      },
      error_message: {},
      connectionLog: [],
      enableLoading: false,
      isEmergencyStop: false,
      valueUpdated: false,
      isProcessAutoIdrop: false,
      isProcessGradingCancelled: false,
      response_msg: null,
      response_data: null,
      lang: "en",
    };

    this.client = null;
    
    this.handleScan = this.handleScan.bind(this);
    this.handleError = this.handleError.bind(this);

    this.scanQRRef = React.createRef();
  }
  

  componentDidMount() {
    
    const { clientId, password, username } = this.props;

    // this._playVoice("https://api-test.dumpster.com.my/audio/drvm/user_verified_en.wav")

    if(clientId && password && username)
    {
      this._updateStateData()

    }else{

      this.setState({page: "login"}, () => {
        
        this.setFieldValidation()
      })
    }
  }


  componentWillUnmount() {
    // clean up on unmount
    this._closeConnection(false);
  }

  

  componentDidUpdate(prevProps) {

    const { deviceInfoState } = this.props;

    if ( JSON.stringify(prevProps.deviceInfoState) !== JSON.stringify(deviceInfoState)) {
      console.log(111)
      this._onSendDeviceStatus()
    }

  }

  setFieldValidation = () => {
    
    let fields = cloneDeep(this.state.fields);

    fields.client_id.validation["additional"] = {
      required: {
        rules: this._validateLoginRequired,
        error_message: "Please Enter Client ID."
      }
    }
    

    fields.password.validation["additional"] = {
      required: {
        rules: this._validateLoginRequired,
        error_message: "Please Enter Password."
      }
    }

    fields.username.validation["additional"] = {
      required: {
        rules: this._validateLoginRequired,
        error_message: "Please Enter Username."
      }
    }
    
    fields.weight.validation["additional"] = {
      required: {
        rules: this._validateWeighingRequired,
        error_message: "Please Enter Weight."
      },
      isValid: {
        rules: this._validateWeighingValid,
        error_message: "Invalid Weight."
      }
    }

    fields.recyclabes_snapshot.validation["additional"] = {
      required: {
        rules: this._validateWeighingRequired,
        error_message: "Please Upload Recyclable Snapshot."
      }
    }
    
    fields.autoidrop_snapshot.validation["additional"] = {
      required: {
        rules: this._validateWeighingRequired,
        error_message: "Please Upload User Autoidrop Snapshot."
      }
    }
    
    this.setState({ fields});
  }

  _validateLoginRequired = value => {

    const { page }  = this.state
    let isValid = true;
        
    if(page === "login")
    {      
      let validator = Validator({ rules: { required: true } }, value);
      isValid = validator.valid;
    }

    return isValid;
  };

  _validateWeighingRequired = value => {

    const { page }  = this.state
    let isValid = true;
        
    if(page === "start_grading")
    {      
      let validator = Validator({ rules: { required: true } }, value);
      isValid = validator.valid;
    }

    return isValid;
  };

  _validateWeighingValid = value => {

    const { page }  = this.state
    let isValid = true
    
    if( page === "start_grading" && value && value < 0)
      isValid = false
    
    return isValid;
  };


  _updateStateData = () => {

    const { clientId, password, username } = this.props;
    let fields = cloneDeep(this.state.fields);

    fields["client_id"].value = clientId
    fields["password"].value = password
    fields["username"].value = username

    this.setState({fields}, () => {

      this.setFieldValidation();

      this.setState({enableLoading: true}, () => {
        this._connectMqtt()
      })
    })
  }

  addLog = (msg) => {
    this.setState((prev) => ({
      connectionLog: [...prev.connectionLog, {"timestamp":moment().format("YYYY-MM-DD HH:mm:ss"),"message":msg}],
    }));
  };

  resetLog = () => {
    this.setState({connectionLog: []});
  };

  _connectMqtt = () => {
    
    const { deviceInfoState } = this.props;
    let fields = cloneDeep(this.state.fields);
    
    this.addLog(`Connecting to broker... ${MQTT_HOST[env]}`);
    
    options.clientId = fields["client_id"].value
    options.password = fields["password"].value
    options.username = fields["username"].value

    // ✅ Connect to broker
    // Use "mqtt://localhost:1883" for TCP, or "ws://your-ip:port" for browser/React
    this.client = mqtt.connect(`${MQTT_HOST[env]}`, options);


    this.client.on("connect", () => {
      
      this.addLog("🟢 Connected to broker");
      console.log("🟢 Connected to broker")

      let activeSta = (!deviceInfoState.boxState || !deviceInfoState.bagState || !deviceInfoState.scannerState || !deviceInfoState.innerCCTVState || !deviceInfoState.outerCCTVState || !deviceInfoState.doorState || !deviceInfoState.weighingState || !deviceInfoState.speakerState ||!deviceInfoState.maglockState) ? false : true
              
      this.setState({vm_status: ((!this.state.isConnected && activeSta) || this.state.vm_status === "offline") ? "free_to_use" : this.state.vm_status, enableLoading: false, isConnectionFail: false}, () => {
      console.log("==isConnected", this.state.isConnected)
        if(!this.state.isConnected)
        {
          console.log(222, this.state.isConnected)
          this.setState({isConnected: true}, () =>{
            this._onSendDeviceStatus(true)
          })
        }  

        if(this.state.page === "login" || this.state.page === "")
          this.setState({page: "home"})

        if(!this.props.clientId || fields["client_id"].value !== this.props.clientId)
        {
          let params = {
            clientId: fields["client_id"].value,
            password: fields["password"].value,
            username: fields["username"].value,
          }

          this.props.onUpdateMqttOption(params)
        }
      })

      // Subscribe to your own response topic
      this.client.subscribe(`order-update/${options.clientId}`, () => {
        console.log(`📡 Subscribed to order-update/${options.clientId}`)
        this.addLog(`📡 Subscribed to order-update/${options.clientId}`)
      });

      // Subscribe to your own response topic
      this.client.subscribe(`smart-bin/${options.clientId}/service-status`, () => {
        console.log(`📡 Subscribed to smart-bin/${options.clientId}/service-status`)
        this.addLog(`📡 Subscribed to smart-bin/${options.clientId}/service-status`)
      });

      // Subscribe to your own response topic
      this.client.subscribe(`smart-bin/${options.clientId}/log-status`, () => {
        console.log(`📡 Subscribed to smart-bin/${options.clientId}/log-status`)
        this.addLog(`📡 Subscribed to smart-bin/${options.clientId}/log-status`)
      });

      // Subscribe to your own response topic
      this.client.subscribe(`smart-bin/audio-update`, () => {
        console.log(`📡 Subscribed to smart-bin/audio-update`)
        this.addLog(`📡 Subscribed to smart-bin/audio-update`)
      });

    });

    this.client.on("close", () => {
      
      this.addLog("🔌 Disconnected")       
      this.setState({ vm_status: "offline", enableLoading: false });
    });

    this.client.on("reconnect", () => {
      this.addLog("🔁 Trying to reconnect...") 
    });

    this.client.on("offline", () => {
      
      this.addLog("⚠️ Server is offline (broker unreachable)")

      this.setState({ vm_status: "offline", isConnectionFail: true, err_msg: "Server is offline (broker unreachable)" }, () => {

        this._closeConnection();

        if(!this.state.isConnected & this.state.page === "")
          this.setState({page: "login"})
        
      })
    });

    this.client.on("error", (err) => {
      
      this.addLog(`🚨 MQTT Error: ${err.message}`)

      this.setState({vm_status: "error", enableLoading: false, isConnectionFail: true, err_msg: err.message}, () => {
        
        this._closeConnection();

        if(!this.state.isConnected && this.state.page === "")
          this.setState({page: "login"})
        
      })
    });

    this.client.on("message", (topic, message) => {
      
      let data = (message && message.toString() !== "") ? JSON.parse(message.toString()) : {}
      console.log(topic)
      console.log(message.toString())
              
      if(data.voice_buffer) data.voice_buffer = ""
      this.addLog(`📬 Message: (topic) ${topic}`)
      this.addLog(`📬 Message: (message) ${JSON.stringify(data)}`)

      if(topic === `order-update/${fields["client_id"].value}`)
      {
          console.log(this.props.orderID, this.props.rfid)
          if(data.userVerify !== undefined && this.state.page === "scan_qr")
          {
            if(this.scanQRRef && this.scanQRRef.current && this.scanQRRef.current.stopCamera) this.scanQRRef.current.stopCamera()

            if(data.userVerify === true && data.rfid && data.orderID)
            {
              this.setState({ valueUpdated: false, page: "dropoff", response_msg: data.msg, lang: (data.lang) ? data.lang : "en"}, () => {

                  this.props.onUpdateCurrentOrder({orderID: data.orderID, rfid: data.rfid})
                  this._playVoice(data.voice_URL)
              });

            }else
            {
              this.setState({ valueUpdated: false, page: "home", vm_status: "free_to_use", screen: "response_status", response_msg: data.msg, lang: (data.lang) ? data.lang : "en" }, () => {
            
                  this._playVoice(data.voice_URL)
              });
            }
          }

          if(data.processGrading !== undefined && data.orderID && data.orderID === this.props.orderID && data.rfid && data.rfid === this.props.rfid)
          {
            // this.setState({ screen: "response_status", response_msg: data.msg, lang: (data.lang) ? data.lang : "en", response_data: null});
            
              this._playVoice(data.voice_URL)
          }

          if(data.gradingCompleted !== undefined && data.orderID && data.orderID === this.props.orderID && data.rfid && data.rfid === this.props.rfid)
          {
            if(data.retry)
            {
              setTimeout(() => {
                console.log("gradingCompleted failed.. retry..")
                this._proceedAutoidrop();
              }, 2000); // 2000 milliseconds = 2 seconds

            }else{
              
              this.setState({ isProcessAutoIdrop: false, screen: "response_status", response_msg: data.msg, response_data: data, lang: (data.lang) ? data.lang : "en"});
    
              if(data.gradingCompleted === true)              
                this.setState({vm_status: "process_end"})

              else
                this._proceedErorLogUpload(data.error_code, "autoIdrop_complete")
              
              console.log("Reset Order!")
              this.props.onUpdateCurrentOrder({orderID: null, rfid: null})

              this._playVoice(data.voice_URL)
            }
          }

          if(data.gradingCancelled && data.orderID && data.orderID === this.props.orderID && data.rfid && data.rfid === this.props.rfid)
          {
            this.setState({ page: "start_grading", gradingCancelled: true });    
          }
          
          if(data.gradingCancelledSuccess !== undefined && data.orderID && data.orderID === this.props.orderID && data.rfid && data.rfid === this.props.rfid)
          {
            if(data.retry)
            {
              setTimeout(() => {
                console.log("gradingCancelledSuccess failed.. retry..")
                this._proceedGradingCancelled();
              }, 2000); // 2000 milliseconds = 2 seconds

            }else{
              this.setState({ isProcessGradingCancelled: false, screen: "response_status", response_msg: data.msg, response_data: null, lang: (data.lang) ? data.lang : "en"});

              if(data.gradingCancelledSuccess === true)              
                this.setState({vm_status: "process_end", gradingCancelled: false})

              else
                this._proceedErorLogUpload(data.error_code, "order_cancel")
                           
              
              console.log("Reset Order!")
              this.props.onUpdateCurrentOrder({orderID: null, rfid: null})

              this._playVoice(data.voice_URL)
            }  
          }

          if(data.emergencyStop)
          {
            if(this.state.screen !== "emergency_stop")
            {
              if(this.scanQRRef && this.scanQRRef.current && this.scanQRRef.current.stopCamera) this.scanQRRef.current.stopCamera()

              this.setState({ page: "home", screen: "emergency_stop", response_msg: data.msg, lang: (data.lang) ? data.lang : "en", isEmergencyStop: true}, () => {

                this._playVoice(data.voice_URL)
              })
            }
          }
      }
      
      if( topic === `smart-bin/${fields["client_id"].value}/log-status` )
      {
        console.log(`Log Upload Status: ${data.status}`)              
      }

      if ( topic === `smart-bin/${fields["client_id"].value}/service-status` ) 
      { 

        if(data.emergencyStop)
        {
          this.setState({ vm_status: "error", isEmergencyStop: true}, () => {

            this._onServiceUpdateResponse("stopService")
          });
        }
        
        if(data.startService)
        {
          this.setState({ vm_status: "free_to_use", isEmergencyStop: false}, () => {
            this._onServiceUpdateResponse("startService")

            if(this.state.page === "unlockMaglock")                
              this.setState({page: "serviceStarted", processUpdateMaglock: false})

            });
        }
      
        if(data.reboot)
        {
          this.setState({ reboot_request_received: true}, () => {
            this._onServiceUpdateResponse("reboot")
          })
        }

        if(data.rebootConfirm && this.state.reboot_request_received)
        {
          setTimeout(() => {
            this.setState({ vm_status: "free_to_use", isEmergencyStop: false, reboot_request_received: false}, () => {
              this._onServiceUpdateResponse("rebootSuccess")
            });
          }, 500); // 500ms debounce
          
        }

        if(data.unlockMaglock)
        {
          this.setState({page: "unlockMaglock", processUpdateMaglock: false}, () => {

            this._onUnlockedMaglock()   
          })         
        }

        if(data.systemError)
        {
          console.log(`service-status failed.. retry (${data.retry})`)

          if(data.retry)
          {
            setTimeout(() => {
              this._onSendDeviceStatus();
            }, 2000); // 2000 milliseconds = 2 seconds
          }else{
            this._proceedErorLogUpload(data.error_code, "update_status")
          }
        }
      }
      
    });

    // setInterval(() => {
    //   const now = moment();
    //   if (this.state.isConnected) {
    //     if (now - lastPingTime > 20000) {
          
    //       this.addLog("⚠️ No ping for 20s, forcing reconnect...")

    //       this.client.end(true); // force disconnect
    //       this.client.reconnect(); // force reconnect
    //     } else {
    //       this.addLog("✅ Still connected")
    //     }
    //   } else {
    //     this.addLog("🕓 Not connected, waiting...")
    //   }
    // }, 10000);

    // this.client.stream.on("data", () => {
      
    //   this.setState({ lastPingTime: moment() }); // update ping time
    // });
    
  }

  _closeConnection = (reconnect = true) => {

    console.log("🔌 Close connection")
    this.addLog("🔌 Close connection")

    if (this.client) {
      this.client.end(true); // hard close the WebSocket, destroy old socket completely

      if(reconnect)
        this.client.reconnect();
    }    
  }

  _enableAudio = () => {
    const audio = new Audio();
    audio.play().catch(() => {}); // iPhone hack
    window.soundUnlocked = true;
    
  };

  _playVoice = (url) => {
    
    console.log("_playVoice", {url})
    // const blob = this._base64ToBlob(base64voice);
    // const audioUrl = URL.createObjectURL(blob);
      
    // alert(`_playVoice soundEnabled:${window.soundEnabled}`)

    // if (!window.soundUnlocked) {
    //   alert("Audio blocked until user enables sound");
    //   return;
    // }

    // if (window.soundEnabled) {
      if(voice_type === "url" && url)
      {
        // Play audio
        const audio = new Audio(url);
        audio.play()
          .then(() => {
            window.soundUnlocked = true;
            // alert("Playing...")
            console.log('Playing...')
          })
          .catch(err => {
            
            window.soundUnlocked = false;
            // alert(`failed... ${err}`)
            console.error('Playback failed:', err)
          });

      }
      
      // if(voice_type === "buffer" && buffer)
      // {
      //   // if(Buffer.isBuffer(buffer))
      //   // {
      //     // payload 是 Uint8Array
      //     const audioBuffer = Buffer.from(buffer);

      //     const blob = new Blob([audioBuffer], { type: 'audio/wav' });
      //     const audio = new Audio(URL.createObjectURL(blob));
      //     audio.play()
      //       .then(() => console.log('Playing...'))
      //       .catch(err => console.error('Playback failed:', err));

      //   // }else{
      //   //   console.log("Invalid wav file")
      //   // }
      // }
    // }
    
  }

  // Convert Base64 to binary
  _base64ToBlob (base64, type = 'audio/wav') {
    const binary = atob(base64); // decode base64 to binary string
    const len = binary.length;
    const buffer = new Uint8Array(len);

    for (let i = 0; i < len; i++) {
      buffer[i] = binary.charCodeAt(i);
    }

    return new Blob([buffer], { type });
  }

  _proceedBack = (discard = false) => {

    const { page } = this.state;

    if(page === "scan_qr"){

      if(this.scanQRRef && this.scanQRRef.current && this.scanQRRef.current.stopCamera)
      {
        console.log("this.scanQRRef", this.scanQRRef)
        this.scanQRRef.current.stopCamera()
        // window.location.reload()
      }
      
      this.setState({vm_status: (this.state.vm_status === "in_use") ? "free_to_use" : this.state.vm_status, page: "home"})

    }else{
      
      this.setState({page: "home"})
    }
  }

  _onProceedLogout = () => {

    this.props.onResetMqttOption();
    this._closeConnection(false);

    this.setState({isConnected: false, page: "login"})
  }
  
  _onSendDeviceStatus = (initial = false) => {
    
    var { deviceInfoState } = this.props;

    if(initial)
    {
        deviceInfoState = {
          boxState: true,
          bagState: true,
          scannerState: true,
          innerCCTVState: true,
          outerCCTVState: true,
          doorState: true,
          weighingState: true,
          speakerState: true,
          maglockState: true,
        }
    }

    if (!this.client || !this.state.isConnected) {
      alert("❌ Not connected to MQTT broker!");
      return;
    }
    console.log({deviceInfoState})
    this.props.onUpdateDeviceInfo(deviceInfoState)

    //Send Device Info
    const payload = JSON.stringify(deviceInfoState);
    this.client.publish("smart-bin/update-status", payload);
  }

  _onTestConnection = () => {

    if (!this.client || !this.state.isConnected) {
      alert("❌ Not connected to MQTT broker!");
      return;
    }

    const payload = JSON.stringify({
      note: "Button clicked in React client",
      timestamp: new Date().toISOString(),
    });

    this.addLog("🚀 Published smart-bin/ping")
    this.client.publish("smart-bin/ping", payload);
  }


  _onServiceUpdateResponse = (action) => {

    if (!this.client || !this.state.isConnected) {
      alert("❌ Not connected to MQTT broker!");
      return;
    }

    const payload = JSON.stringify({
      action,
      status: true,
      timestamp: new Date().toISOString(),
    });

    this.addLog("🚀 Published smart-bin/response")
    this.client.publish("smart-bin/response", payload);
  }


  _onUpdateBoxFull = () => {

    const { deviceInfoState } = this.props;

    let updateInfo = {...deviceInfoState}

    updateInfo.bagState = !deviceInfoState.bagState

    this.props.onUpdateDeviceInfo(updateInfo)

  }

  _onUnlockedMaglock = () => {

    const { deviceInfoState } = this.props;

    let updateInfo = {...deviceInfoState}

    updateInfo.maglockState = false

    this.props.onUpdateDeviceInfo(updateInfo)

  }

  _onLockedMaglock = () => {

    const { deviceInfoState } = this.props;

    let updateInfo = {...deviceInfoState}

    updateInfo.maglockState = true

    this.setState({processUpdateMaglock: true}, () => {

      this.props.onUpdateDeviceInfo(updateInfo)
    })

  }

  _handleChange = (e, value = "") => {
    const { page } = this.state;
    let fields = cloneDeep(this.state.fields);
    let name = "";
    
    if (typeof e === "string") {
      name = e;
    } else {
      name = e.target.name;

      switch (e.target.type) {
        case "checkbox":
          value = e.target.checked;
          break;
        default:
          value = e.target.value;
          break;
      }
    }
    
    fields[name].value = value;

    this.setState({ fields }, () => {
      this._handleBlur(name);

      if(page === "start_grading")
        this.setState({ valueUpdated: true })
    });
  };

  _handleBlur = e => {
    let fields = cloneDeep(this.state.fields);
    let error_message = cloneDeep(this.state.error_message);
    let name = "";

    if (typeof e === "string") {
      name = e;
    } else {
      name = e.target.name;
    }

    this.setState({fields}, () => {

      let validator = validateField(fields, name, error_message);

      this.setState({ ...validator });
    })
  };

  
  _onSubmit = async () => {
    const { page, gradingCancelled } = this.state;
    let fields = cloneDeep(this.state.fields);
    let error_message = cloneDeep(this.state.error_message);
    let validator = await validateForm(fields, error_message);

    this.setState({ ...validator.data }, () => {
      console.log({page, validator})
      if (validator.valid) {

        if(page === "login")
        {
          this.setState({enableLoading: true}, () => {
            this.resetLog()
            this._connectMqtt()
          })

        }else if(page === "start_grading")
        {
          if(gradingCancelled)
            this._proceedGradingCancelled();

          else
            this._proceedAutoidrop();
        }
      }
    });
  };

  
  /* ===== Scan QR Code  =====*/  
  _onProceedQRScan = () => {

    // this._playVoice("https://api-test.dumpster.com.my/audio/drvm/user_verified_en.wav");
    // const audio = new Audio("https://api-test.dumpster.com.my/audio/drvm/user_verified_en.wav");
    // audio.play()
    //   .then(() => {
    //     window.soundUnlocked = true;
    //     alert("Audio unlocked on iPhone");
    //   })
    //   .catch(() => {
    //     window.soundUnlocked = false;
    //     alert("Audio unlock failed");
    //   });

    this.setState({vm_status: "in_use", page: "scan_qr", qrcode_key: ""}, () => {

      //  this._onVerifyUser("10230615210620");
    })
  }

  handleScan(data) {
    if (data) {

      this.setState({qrcode_key: data}, () => {
        
        this._onVerifyUser(data);
      })
    }
  }

  handleError(err) {
    console.error(err);
  }
  
  renderScanQR = () => {
      
      return (
        <div className="scan-qr-container" style={{background: `${Color.Black}`, height: window.innerHeight}}>
          <div className="">
            <QrReader     
              className="pt-5"       
              facingMode='environment'
              delay={300}
              style={{ width: '100%'}}
              onError={this.handleError}
              onScan={this.handleScan}
              ref={this.scanQRRef}
            />
            <p>{this.state.qrcode_key}</p>
          </div>
          <div className="text-center pt-2" style={{color: "#fff"}}>Please scan the user QR</div>
        </div>
      )
  }
  
  _onVerifyUser = (qrcode) => {

    if (!this.client || !this.state.isConnected) {
      alert("❌ Not connected to MQTT broker!");
      return;
    }

    const payload = JSON.stringify({ user_identifier: qrcode });

    this.addLog(`🚀 Published smart-bin/verify-user: ${payload}`)
    this.client.publish("smart-bin/verify-user", payload);
  }
  /* ===== Scan QR Code End =====*/ 


  
  /* ===== Grading Process  =====*/ 

  _uploadImageSelection = (image_type) => {

    // let userAgent = navigator.userAgent

    // if(userAgent.search("iPhone;") > -1)
    if(/Android|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent))
      this.setState({screen: "selection", image_type})

    else{
      
      this.setState({image_type}, () => {

        this._onSelectPhotos()
      })
    }

  }

  _onDismissSelection = () => {

    this.setState({screen: ""})
  }

  _onSelectPhotos = () => {
    const { image_type } = this.state;

    if(image_type === "recyclabes_snapshot")
      this.uploadRS.click()

    else if(image_type === "autoidrop_snapshot")
      this.uploadAS.click()
  }

  _onSelectCamera = () => {
    const { image_type } = this.state;

    if(image_type === "recyclabes_snapshot")
      this.captureRS.click()

    else if(image_type === "autoidrop_snapshot")
      this.captureAS.click()
  }
  
  _onSelectFile = (event, key) => {

    const file = event.target.files;
    if(file[0])
      this._convertToBase64(file[0], key);
      
  };

  _convertToBase64 = (file, key) => {
    let fields = cloneDeep(this.state.fields);

    fields[key].value = {file};

    this.setState({ fields, valueUpdated: true }, () => {      

      const reader = new FileReader();
      reader.addEventListener("load", () => {
        
          let fields = cloneDeep(this.state.fields); 
          let error_message = cloneDeep(this.state.error_message);
          
          if(key === "recyclabes_snapshot")
            fields["recyclabes_snapshot_url"].value = reader.result;

          else if(key === "autoidrop_snapshot")
            fields["autoidrop_snapshot_url"].value = reader.result;

          let validator = validateField(fields, key, error_message)

          this.setState({ ...validator, fields, screen: "" });
        
      });
      reader.readAsDataURL(file);
    });
  };

  _onViewDocument = (doc, pg) => {

    this.setState({ selectedDoc: {doc, pg}, page: "view_document"})
  }

  _removeImage = (doc) => {

    let fields = cloneDeep(this.state.fields);

    if(doc === "recyclabes_snapshot")
    {
      fields["recyclabes_snapshot"].value = null
    fields["recyclabes_snapshot_url"].value = ""
    }

    if(doc === "autoidrop_snapshot")
    {
      fields["autoidrop_snapshot"].value = null
      fields["autoidrop_snapshot_url"].value = ""
    }

    this.setState({ fields })
  }

  _proceedCloseDoor = () => {
    
    const { orderID, rfid } = this.props;

    if (!this.client || !this.state.isConnected) {
      alert("❌ Not connected to MQTT broker!");
      return;
    }
    
    const payload = JSON.stringify({ orderID, rfid });

    this.setState({page: "start_grading"} ,() => {

      this.addLog(`🚀 Published activities/autoIdrop_grading: ${payload}`)
      this.client.publish("activities/autoIdrop_grading", payload);
    })
  }

  _proceedAutoidrop = () => {
    
    const { orderID, rfid } = this.props;
    const { fields } = this.state;

    if (!this.client || !this.state.isConnected) {
      alert("❌ Not connected to MQTT broker!");
      return;
    }
    
    const payload = JSON.stringify({ orderID, rfid, data:{recyclabes_snapshot: fields["recyclabes_snapshot_url"].value, autoidrop_snapshot: fields["autoidrop_snapshot_url"].value, weight: fields["weight"].value} });
    
    const payload2 = JSON.stringify({ orderID, rfid, data:{recyclabes_snapshot: "base64", autoidrop_snapshot: "base64", weight: fields["weight"].value} });

    this.setState({isProcessAutoIdrop: true} ,() => {

      this.addLog(`🚀 Published activities/autoIdrop_complete: ${payload2}`)
      this.client.publish("activities/autoIdrop_complete", payload);
    })
  }

  _proceedLogUpload = () => {

    if (!this.client || !this.state.isConnected) {
      alert("❌ Not connected to MQTT broker!");
      return;
    }

    // const enc = new TextEncoder()    
    // const buf = enc.encode(this.state.connectionLog) // convert string → binary

    
    const payload = JSON.stringify({ level: "INFO", content: JSON.stringify(this.state.connectionLog) });
    
    this.addLog(`🚀 Published smart-bin/upload-log`)
    this.client.publish("smart-bin/upload-log", payload);
    
  }

  _proceedErorLogUpload = (error_code, error_from) => {

    if (!this.client || !this.state.isConnected) {
      alert("❌ Not connected to MQTT broker!");
      return;
    }

    // const enc = new TextEncoder()    
    // const buf = enc.encode(this.state.connectionLog) // convert string → binary

    const payload = JSON.stringify({ level: "ERROR", content: JSON.stringify(this.state.connectionLog), error_code, error_from });
    
    this.addLog(`🚀 Published smart-bin/upload-log`)
    this.client.publish("smart-bin/upload-log", payload);
    
  }

  resetGradingForm = () => {

    let fields = cloneDeep(this.state.fields);

    fields["weight"].value = 0
    fields["recyclabes_snapshot"].value = null
    fields["autoidrop_snapshot"].value = null
    fields["recyclabes_snapshot_url"].value = ""
    fields["autoidrop_snapshot_url"].value = ""
    
    this.setState({fields})
  }

  _onDismissResponseStatus = (success) => {

    if(success)
    {
      this.setState({vm_status: (this.state.vm_status === "process_end") ? "free_to_use" : this.state.vm_status, screen: "", page: "home"}, () => {

        this.resetGradingForm()
      })

    }else{
      this.setState({screen: ""})
    }
  }

  _proceedGradingCancelled = () => {
    
    const { orderID, rfid } = this.props;
    const { fields } = this.state;

    if (!this.client || !this.state.isConnected) {
      alert("❌ Not connected to MQTT broker!");
      return;
    }
    
    const payload = JSON.stringify({ orderID, rfid, data:{recyclabes_snapshot: fields["recyclabes_snapshot_url"].value, autoidrop_snapshot: fields["autoidrop_snapshot_url"].value, weight: fields["weight"].value} });
    
    const payload2 = JSON.stringify({ orderID, rfid, data:{recyclabes_snapshot: "base64", autoidrop_snapshot: "base64", weight: fields["weight"].value} });

    this.setState({isProcessGradingCancelled: true} ,() => {

      this.addLog(`🚀 Published order-cancel/response: ${payload2}`)
      this.client.publish("order-cancel/response", payload);
    })
  }
  /* ===== Grading Process End =====*/ 


  _onDismissScreen = () => {
    
    this.setState({page: "home", screen: ""})
  }

  _onDismissLog = () => {
    
    this.setState({screen: ""})
  }

  _showLog = () => {
    
    this.setState({screen: "show_log"})
  }

  render() {

    const { deviceInfoState } = this.props;
    const { page, screen, view, isConnected, isConnectionFail, fields, err_msg, enableLoading, connectionLog, vm_status } = this.state;

    return (      
      <React.Fragment>
            
        {page === "scan_qr" && (  
                                  
          <CustomPageStyle>
            <div className="pg-header">
              <div 
                className={`backBtn color-white`}
                onClick={() => this._proceedBack()}
              >                
                <i className={'font-20 ion-android-arrow-back'}/>
                
              </div>
            </div>
            <div>     
              {this.renderScanQR()} 
            </div>     
          </CustomPageStyle>             
        )}

        {page !== "scan_qr" && ( 
          <Spin className="test" spinning={enableLoading}>
            <CustomPageStyle>
              {page === "start_grading" && (  
                <div className="pg-header">
                  <div 
                    className={`backBtn`}
                    onClick={() => this._proceedBack()}
                  >                
                    <i className={'font-20 ion-android-arrow-back'}/>
                    
                  </div>
                </div>
              )}
              
              <LayoutContentWrapper className={`${page === "login" ? "pt-0 pl-0 pr-0" : "mb-5"}`}>

                {(page === "login" || !isConnected) && (

                    <div>
                      <div className="isoLoginContentWrapper">

                        <div className={`isoLoginContent pt-0`}>

                            <div className="color-primary font-bold font-30">Welcome to DRVM!</div>
                            
                            <div className="mt-1 font-17">Please proceed with username and password to Start Connection.</div>

                            <div className="isoSignInForm mt-4">
                              <Form layout="vertical">

                                <div className="isoInputWrapper">
                                    
                                  <FormItem 
                                    label="Client ID"
                                    validateStatus={
                                      !fields["client_id"].valid ? "error" : "validating"
                                    }
                                    help={this.state.error_message["client_id"]}
                                  >
                                    <div className="pt-1">
                                      <Input
                                        size="large"
                                        type="text"
                                        name="client_id"
                                        autoComplete="off"
                                        value={fields["client_id"].value}
                                        onChange={this._handleChange}
                                        onBlur={this._handleBlur}
                                      />
                                      </div>
                                  </FormItem>
                                  
                                  <FormItem 
                                    label="Username"
                                    validateStatus={
                                      !fields["username"].valid ? "error" : "validating"
                                    }
                                    help={this.state.error_message["username"]}
                                  >
                                    <div className="pt-1">
                                      <Input
                                        size="large"
                                        type="text"
                                        name="username"
                                        autoComplete="off"
                                        value={fields["username"].value}
                                        onChange={this._handleChange}
                                        onBlur={this._handleBlur}
                                      />
                                      </div>
                                  </FormItem>
                                  
                                  <FormItem 
                                    label="Password"
                                    validateStatus={
                                      !fields["password"].valid ? "error" : "validating"
                                    }
                                    help={this.state.error_message["password"]}
                                  >
                                    <div className="pt-1">
                                      <Input
                                        size="large"
                                        type="text"
                                        name="password"
                                        autoComplete="off"
                                        value={fields["password"].value}
                                        onChange={this._handleChange}
                                        onBlur={this._handleBlur}
                                      />
                                      </div>
                                  </FormItem>
                                </div>

                                {isConnectionFail && isConnectionFail && (

                                  <div className="text-danger">{err_msg}</div>
                                )}
                                
                                <div 
                                  className={`isoInputWrapper isoLeftRightComponent ${isConnectionFail ? "pt-3" : "pt-4"}`}
                                  onClick={() => this._onSubmit()}
                                >
                                  PROCEED
                                </div>
                                
                              </Form>
                            </div>

                        </div>
                      </div>
                    </div>
                    
                )}

                {page === "home" && isConnected && (
                  <div>

                    <div className="profile-container mb-3">
                      <div className="align-middle">
                          <div className="font-24 pl-2 pr-2">{fields["client_id"].value}</div>
                          <div className={`status-circle ${vm_status} mt-2`}></div>
                      </div>
                      <div>
                        {/* <div>
                           <button 
                              onClick={this._enableAudio}
                              style={{
                                padding: "12px 20px",
                                background: "#007bff",
                                color: "white",
                                borderRadius: "6px",
                                fontSize: "16px",
                                border: "none",
                                cursor: "pointer",
                              }}
                            >
                              🔊
                            </button>
                        </div> */}
                        <div 
                          className="isoIconWrapper"
                          onClick={() => this._onProceedLogout()}
                        >                    
                          <img alt="" src={offBtn}/>
                          
                        </div>
                      </div>
                    </div>


                    <div className="dashboard text-center">
                      <div className="card full-width" onClick={() => this._onProceedQRScan()}>
                        <div className="icon recycle-start"></div>
                        <div>Start order</div>
                      </div>
                    </div>

                    <div className="dashboard">
                      <div className="card icon-box" onClick={() => this._onTestConnection()}>
                        <div className="icon ping-test small"></div>
                        <div className="mt-4 pl-2">Test Connection</div>
                      </div>
                      
                      <div className="card icon-box" onClick={() => this._onUpdateBoxFull()}>
                        <div className="d-flex justify-content-between">
                          <div className="icon bag-full small"></div>
                          <div className="switch-btn">
                            <Switch 
                              checked={!deviceInfoState.bagState ? true : false}
                              onColor={Color.Secondary}
                              onHandleColor={Color.White}
                              uncheckedIcon={false}
                              checkedIcon={false}
                              onChange={() => {}}
                            /> 
                          </div>
                        </div>
                        <div className="mt-4 pl-2">Box Full</div>
                      </div>
                    </div>

                    <div className="mb-3">
                      <div className="d-flex justify-content-between">
                        <div className="font-bold pb-2 pl-2 pt-2">Activity Logs</div>
                        <div>
                          <i className="ion-android-upload font-24" onClick={this._proceedLogUpload}/>
                        </div>
                      </div>
                      <div
                        style={{
                          background: "radial-gradient(circle at center, #2c2c2c, #2d2d2d 60%, #2f2f2f 100%)",
                          color: "rgb(136 136 136)",
                          padding: 10,
                          height: 200,
                          overflowY: "auto",
                          borderRadius: 6,
                          fontSize: 12,
                        }}
                      >
                        {connectionLog.map((log, i) => (
                          <div key={i}>{log.timestamp} {log.message}</div>
                        ))}
                      </div>
                    </div>
                        
                  </div>
                )}

                {page === "dropoff" && (
                  <div>
                    <div className="pg-content">
                      <div>                        
                          <div className="alert-msg">{activtyMessage.user_verified[this.state.lang]}</div>
                          <img alt="" src={DropOffDRVM} className="width100"/>
                      </div>
                      
                      <div className="mt-3">
                        <Button
                          className="bottom-btn green-btn width100"
                          type="default"          
                          onClick={() => this._proceedCloseDoor()}
                          loading={this.state.isProcessAutoIdrop}
                        >
                          Close Door
                        </Button>
                      </div>
                      
                      <div className="text-center pt-3 bottomText" onClick={() => this._showLog()}>Show Log ^</div>
                    </div>
                  </div>
                )}

                {page === "unlockMaglock" && (
                  <div>
                    <div className="pg-content">
                      <div>                        
                          <div className="alert-msg">Scan successful. Lock is now open</div>
                          <img alt="" src={DropOffDRVM} className="width100"/>
                      </div>
                      
                      <div className="mt-3">
                        <Button
                          className="bottom-btn green-btn width100"
                          type="default"          
                          onClick={() => this._onLockedMaglock()}
                          loading={this.state.processUpdateMaglock}
                        >
                          Close Door
                        </Button>
                      </div>
                      
                    </div>
                  </div>
                )}

                {page === "serviceStarted" && (
                  <div>
                    <div className="pg-content">
                      <div>                        
                          <div className="alert-msg">Service Start! Welcome back to DRVM!</div>
                          <img alt="" src={DropOffDRVM} className="width100"/>
                      </div>
                      
                      <div className="mt-3">
                        <Button
                          className="bottom-btn green-btn width100"
                          type="default"          
                          onClick={() => this._onDismissScreen()}
                        >
                          Ok
                        </Button>
                      </div>
                      
                    </div>
                  </div>
                )}


                {page === "start_grading" && (
                  <div>
                    <div className="pg-content">
                      {/* Weight */}
                      <FormItem
                        label="Weight (KG)"
                        validateStatus={
                          !fields["weight"].valid ? "error" : "validating"
                        }
                        help={this.state.error_message["weight"]}
                      >
                          <div className="pt-1">
                            <Input
                              size="large"
                              type="number"
                              name="weight"  
                              placeholder="0.00" 
                              value={fields["weight"].value}
                              onChange={this._handleChange}
                              onBlur={this._handleBlur}
                            />
                          </div>
                      </FormItem>
                      {/* END Weight */}

                      
                      {/* Recyclabes Snapshot */}
                      <FormItem
                        label="Recyclabes Snapshot"
                        validateStatus={
                          !fields["recyclabes_snapshot"].valid ? "error" : "validating"
                        }
                        help={this.state.error_message["recyclabes_snapshot"]}
                      >
                        <div className="isoImageCon pt-1">       
                          
                          <input
                            type="file"
                            name="uploadRS"
                            onChange={e => this._onSelectFile(e, "recyclabes_snapshot")}
                            accept="image/*"
                            ref={ref => {
                              this.uploadRS = ref;
                            }}
                            className="hidden"
                          />
                          
                          <input 
                            type="file" 
                            name="captureRS"
                            accept="image/*" 
                            capture="environment"
                            onChange={e => { this._onSelectFile(e, "recyclabes_snapshot"); }}
                            ref={ref => {
                              this.captureRS = ref;
                            }}
                            className="hidden"
                          />

                          {fields["recyclabes_snapshot_url"].value ? (
                            
                            <div className="file-wrapper" > 
                              <div 
                                className="image-container clickable table-cell"                    
                                onClick={() => this._onViewDocument(fields["recyclabes_snapshot_url"].value, "start_grading")}
                              >
                                <img alt="" className="image" crossOrigin="anonymous" src={fields["recyclabes_snapshot_url"].value} />
                              </div>

                              <div className="table-cell">
                                <div
                                  className="btn-remove-image-container clickable"
                                  onClick={() => this._removeImage("recyclabes_snapshot")}
                                >
                                  <Icon
                                    type="antd"
                                    name="close"
                                    color={Color.White}
                                    size={18}
                                  />
                                </div>
                              </div>
                            </div>
                          ) : (
                            <React.Fragment>
                              
                              <div className="image-wrapper full-weight">      
                                <div
                                  className="isoIcon"
                                  onClick={() => this._uploadImageSelection("recyclabes_snapshot")}
                                >     
                                  <div className="pt-2">             
                                    <Icon
                                      type="custom"
                                      name="upload"
                                      color={Color.Secondary}
                                      size={25}
                                    />
                                    <p className="font-bold mb-0">Add Photo</p>
                                  </div> 
                                </div>
                              </div>
                            </React.Fragment>
                          )}
                        </div>               
                      </FormItem>
                      {/* END Recyclabes Snapshot */} 

                      
                      {/* Autoidrop Snapshot */}
                      <FormItem
                        label="User AutoIdrop Snapshot"
                        validateStatus={
                          !fields["autoidrop_snapshot"].valid ? "error" : "validating"
                        }
                        help={this.state.error_message["autoidrop_snapshot"]}
                      >
                        <div className="isoImageCon pt-1">       
                          
                          <input
                            type="file"
                            name="uploadAS"
                            onChange={e => this._onSelectFile(e, "autoidrop_snapshot")}
                            accept="image/*"
                            ref={ref => {
                              this.uploadAS = ref;
                            }}
                            className="hidden"
                          />
                          
                          <input 
                            type="file" 
                            name="captureAS"
                            accept="image/*" 
                            capture="environment"
                            onChange={e => { this._onSelectFile(e, "autoidrop_snapshot"); }}
                            ref={ref => {
                              this.captureAS = ref;
                            }}
                            className="hidden"
                          />

                          {fields["autoidrop_snapshot_url"].value ? (

                            <div className="file-wrapper" > 
                              <div 
                                className="image-container clickable table-cell"                    
                                onClick={() => this._onViewDocument(fields["autoidrop_snapshot_url"].value, "start_grading")}
                              >
                                <img alt="" className="image" crossOrigin="anonymous" src={fields["autoidrop_snapshot_url"].value} />
                              </div>

                              <div className="table-cell">
                                <div
                                  className="btn-remove-image-container clickable"
                                  onClick={() => this._removeImage("autoidrop_snapshot")}
                                >
                                  <Icon
                                    type="antd"
                                    name="close"
                                    color={Color.White}
                                    size={18}
                                  />
                                </div>
                              </div>
                            </div>
                          ) : (
                            <React.Fragment>
                              
                              <div className="image-wrapper full-weight">      
                                <div
                                  className="isoIcon"
                                  onClick={() => this._uploadImageSelection("autoidrop_snapshot")}
                                >     
                                  <div className="pt-2">             
                                    <Icon
                                      type="custom"
                                      name="upload"
                                      color={Color.Secondary}
                                      size={25}
                                    />
                                    <p className="font-bold mb-0">Add Photo</p>
                                  </div> 
                                </div>
                              </div>
                            </React.Fragment>
                          )}
                        </div>               
                      </FormItem>
                      {/* END User Autoidrop Snapshot */} 

                      <div className="mt-3">
                        <Button
                          className="bottom-btn green-btn width100"
                          type="default"          
                          onClick={() => this._onSubmit()}
                          loading={this.state.isProcessAutoIdrop || this.state.isProcessGradingCancelled}
                        >
                          Submit
                        </Button>
                      </div>
                    </div>
                    
                  </div>
                )}
                
                {screen !== "" && (
                  <div className="ant-modal-root">
                    <div className="ant-modal-mask"></div>
                    <div className={`ant-modal-wrap instagram-modal`}>
                      <div className="ant-modal">
                        <div className="ant-modal-content">
                          <div className="ant-modal-body">

                            {screen === "selection" && (
                              <div className="button-selection">

                                {view !== "DesktopView" && (
                                  <Button
                                    className="selection"
                                    size="large"
                                    type="default"
                                    onClick={() => this._onSelectCamera()}
                                  >
                                    Camera
                                  </Button>
                                )}
                                
                                <div className="mt-2">
                                  <Button
                                    className="selection"
                                    size="large"
                                    type="default"
                                    onClick={() => this._onSelectPhotos()}
                                  >
                                    Photos
                                  </Button>
                                </div>

                                <div className="mt-2">
                                  <Button
                                    className="bottom-btn grey-btn"
                                    size="large"
                                    type="default"
                                    onClick={() => this._onDismissSelection()}
                                  >
                                    Cancel
                                  </Button>
                                </div>
                              </div>
                            )}


                            {screen === "discard_change" && (
                              <div>
                                <div className="pending-order-container mb-3">
                                  <div className="text-bold font-18">Discard The Changes? </div>
                                </div>
      
                                <div className="d-flex justify-content-between">                        
      
                                  <Button
                                    className="bottom-btn grey-btn mr-2 width100"
                                    size="large"
                                    type="default"
                                    onClick={() => this._proceedBack(true)}
                                  >
                                    Discard
                                  </Button>
      
                                  <Button
                                    className="bottom-btn green-btn ml-2 width100"
                                    size="large"
                                    type="default"
                                    onClick={() => this._onDismissSelection()}
                                  >
                                    Cancel
                                  </Button>
                                </div>
                              </div>
                            )}
                            
                            {screen === "response_status" && (
                              <div>
                                <div className="pending-order-container mb-3">
                                  <div>
                                    <img alt="" crossOrigin="anonymous" src={speaker} width="50px"/>
                                  </div>
                                  {this.state.response_data ? (

                                    <div className="text-bold font-18">{util.format(activtyMessage[this.state.response_msg][this.state.lang], this.state.response_data.weight, this.state.response_data.amount)}</div>
                                  ) : (
                                    
                                    <div className="text-bold font-18">{activtyMessage[this.state.response_msg][this.state.lang]} </div>
                                  )}

                                </div>
      
                                <div>                        
                                  {this.state.response_msg && ["user_verified", "process_grading"].includes(this.state.response_msg) && (
                                    <Button
                                      className="bottom-btn green-btn width100"
                                      size="large"
                                      type="default"
                                      onClick={() => this._onDismissResponseStatus()}
                                    >
                                      Ok
                                    </Button>
                                  )}            

                                  {this.state.response_msg && ["grading_completed", "grading_cancelled"].includes(this.state.response_msg) && (
                                    <Button
                                      className="bottom-btn green-btn width100"
                                      size="large"
                                      type="default"
                                      onClick={() => this._onDismissResponseStatus(true)}
                                    >
                                      Ok
                                    </Button>
                                  )}
      
                                  {this.state.response_msg && ["system_error"].includes(this.state.response_msg) && (
                                    <Button
                                      className="bottom-btn grey-btn width100"
                                      size="large"
                                      type="default"
                                      onClick={() => this._onDismissResponseStatus()}
                                    >
                                      Ok
                                    </Button>
                                  )}
      
                                  {this.state.response_msg && ["user_unverified", "qrcode_unverified"].includes(this.state.response_msg) && (
                                    <Button
                                      className="bottom-btn grey-btn width100"
                                      size="large"
                                      type="default"
                                      onClick={() => this._onDismissResponseStatus(true)}
                                    >
                                      Ok
                                    </Button>
                                  )}
                                </div>
                              </div>
                            )}
                            

                            {screen === "emergency_stop" && (
                              <div className="buttonBottom grading-progress">

                                <div className="in-progress-container mb-4">          
                                  <div className="font-20 font-bold pt-1">Emergency Stop Activated!</div>                                  
                                  <div className="pt-3">
                                    {this.state.response_msg && (
                                      <div className="font-15">{activtyMessage[this.state.response_msg][this.state.lang]} </div>
                                    )}
                                  </div>
                                </div>  

                                <Button
                                  type="default"
                                  size="large"
                                  className="bottom-btn green-btn width100"
                                  onClick={() => this._onDismissScreen()}
                                >
                                  Okay
                                </Button>
                              </div>
                            )}

                            {screen === "show_log" && (
                              <div className="buttonBottom grading-progress">

                                <div
                                  style={{
                                    background: "radial-gradient(circle at center, #2c2c2c, #2d2d2d 60%, #2f2f2f 100%)",
                                    color: "rgb(136 136 136)",
                                    padding: 10,
                                    height: 200,
                                    overflowY: "auto",
                                    borderRadius: 6,
                                    fontSize: 12,
                                  }}
                                >
                                  {connectionLog.map((log, i) => (
                                    <div key={i}>{log.timestamp} {log.message}</div>
                                  ))}
                                </div>

                                <Button
                                  type="default"
                                  size="large"
                                  className="bottom-btn green-btn width100"
                                  onClick={() => this._onDismissLog()}
                                >
                                  Close
                                </Button>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </LayoutContentWrapper>
            
              {(page === "login"||  page === "")  && (
                <div className="text-center pt-3 bottomText">V{APP_VERSION} - {(APP_ENV) ? APP_ENV.slice(0,1).toUpperCase(): ""}</div>
              )}

              {(page === "" || page === "login" || page === "home") && (

                <SwitchService/>
              )}

            </CustomPageStyle>
          </Spin>         
        )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  
  const { view } = state.App;
  const { clientId, password, username, deviceInfoState, orderID, rfid } = state.Auth;

  return { view, clientId, password, username, deviceInfoState, orderID, rfid };
};


const mapDispatchToProps = dispatch => {
  return {
    
    onUpdateMqttOption: (data) => dispatch(actions.updateMqttOption(data)),
    onResetMqttOption: () => dispatch(actions.resetMqttOption()),
    onUpdateDeviceInfo: (data) => dispatch(actions.updateDeviceInfo(data)),
    onUpdateCurrentOrder: (data) => dispatch(actions.updateCurrentOrder(data)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DRVM);
